export default "__VITE_ASSET__D7q_g7P1__"